@if (!isCookiePolicyAccepted) {
  <div
    class="cookie-policy-popup theme-cookieNotification__bg"
    [ngClass]="{ 'cookie-policy-popup--colorSettingsMode': colorSettingsMode }"
  >
    <div class="cookie-policy-popup__desc">
      <p>
        {{ lg.cookiePolicyPopup.description }}
        <a class="theme-cookieNotification__link" routerLink="/cookie-policy">{{ lg.cookiePolicyPopup.btnReadMore }}</a>
      </p>
    </div>
    <div class="cookie-policy-popup__btn">
      <bmcore-button
        title="{{ lg.cookiePolicyPopup.btnAccept }}"
        themeBtnClass="theme-btn__cookieNotification"
        [styleName]="'center'"
        (clickHandler)="acceptedCookie()"
      >
      </bmcore-button>
    </div>
  </div>
}
